import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    COLOR,
    paletaTonsAzul,
} from '../../../business-const/Color/Color'

import {
    arrayConverteZeroNULL,
} from '../../../business-components/Array/Array'

import {
    GridContainer,
    GridContainerS0,
    GridItem11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    ChartPadrao
} from '../../../business-components/Chart/Chart'

import {
    relatorioModoApresentacao,
} from '../estudo-form/EstudoService'

import {
    CardGridEstudoPadrao,
} from '../estudo-form/EstudoComp'

import {
    serieVazia
} from './ChartService'

import {
    aplicarInflacaoCarteiraInvestimentos
} from '../estudo-form/EstudoServiceMatematicaFinanceira'



const CarteiraInvestimentosChart = ( { values, estudo, report, popup, simulacaoFinanceira } ) => {

    const EstrategiasFinanceiras = ( props ) => {

        const series = []

        const paletaCoresEspecifica = []



        if (simulacaoFinanceira) {
            
            series.push(
                {
                    name: LABEL.reservaSuperavit,
                    type: 'bar',
                    data: aplicarInflacaoCarteiraInvestimentos(values, estudo,
                        estudo.current.graficoIndependenciaFinanceiraPrimeiraReuniaoSituacaoRealSuperavit, 0,
                            values.aplicarTaxaInflacaoCarteiraInvestimentos),
                },
            )
    
            paletaCoresEspecifica.push(
                COLOR().corChartPadraoVerde
            )
    
            series.push(
                {
                    name: LABEL.reservaDeficit,
                    type: 'bar',
                    data: aplicarInflacaoCarteiraInvestimentos(values, estudo,
                        estudo.current.graficoIndependenciaFinanceiraPrimeiraReuniaoSituacaoRealDeficit, 0,
                            values.aplicarTaxaInflacaoCarteiraInvestimentos),
                },
            )
    
            paletaCoresEspecifica.push(
                COLOR().corChartPadraoVermelho,
            )

        } else {

            //estudo.current.graficoEstrategiasFinanceirasRecursosFinanceirosAcumulados?.forEach(
            //    (linhaGraficoEstrategiasFinanceirasRecursosFinanceirosAcumulados, index) => {
            
            //    series.push(
            //        {
            //            name: linhaGraficoEstrategiasFinanceirasRecursosFinanceirosAcumulados.descricao,
            //            type: "bar",
            //            data: aplicarInflacaoCarteiraInvestimentos(values, estudo,
            //              linhaGraficoEstrategiasFinanceirasRecursosFinanceirosAcumulados.serie, 0,
            //                  values.aplicarTaxaInflacaoCarteiraInvestimentos),
            //        },
            //    )
        
            //    paletaCoresEspecifica.push(
            //        paletaTonsAzul[index]
            //    )
            //})
            estudo.current.graficoDiagnosticoAposentadoriaRecursosFinanceirosAcumulados?.forEach( (linhaGraficoDiagnosticoAposentadoriaRecursosFinanceirosAcumulados, index) => {
        
                series.push(
                    {
                        name: linhaGraficoDiagnosticoAposentadoriaRecursosFinanceirosAcumulados.descricao,
                        type: "bar",
                        data: aplicarInflacaoCarteiraInvestimentos(values, estudo,
                            linhaGraficoDiagnosticoAposentadoriaRecursosFinanceirosAcumulados.serie, 0,
                                values.aplicarTaxaInflacaoCarteiraInvestimentos),
                    },
                )
        
                paletaCoresEspecifica.push(
                    linhaGraficoDiagnosticoAposentadoriaRecursosFinanceirosAcumulados.descricao === LABEL.economiaReceitaMensal
                        ?
                            COLOR().corChartPadraoAporteAposentadoriaBalancoPositivo
                        :
                            paletaTonsAzul[index]
                )
            })

            series.push(
                {
                    name: LABEL.liquidezFinanceiraAcumuladaSuperavit,
                    type: "bar",
                    data: arrayConverteZeroNULL(aplicarInflacaoCarteiraInvestimentos(values, estudo,
                        estudo.current.graficoDiagnosticoAposentadoriaLiquidezFinanceiraAcumuladaAtualSuperavit, 0,
                            values.aplicarTaxaInflacaoCarteiraInvestimentos)),
                },
            )
    
            paletaCoresEspecifica.push(
                COLOR().corChartPadraoVerde
            )
    
            series.push(
                {
                    name: LABEL.liquidezFinanceiraAcumuladaDeficit,
                    type: "bar",
                    data: arrayConverteZeroNULL(aplicarInflacaoCarteiraInvestimentos(values, estudo,
                        estudo.current.graficoDiagnosticoAposentadoriaLiquidezFinanceiraAcumuladaAtualDeficit, 0,
                            values.aplicarTaxaInflacaoCarteiraInvestimentos)),
                },
            )
    
            paletaCoresEspecifica.push(
                COLOR().corChartPadraoVermelho
            )
        }

        if (
                values.exibirTabelaEvolucaoValorResgateCarteiraInvestimentos &&
                estudo.current.graficoEstrategiasFinanceirasTabelaEvolucaoValorResgate.length > 0
        ) {
        
            series.push(
                {
                    name: LABEL.tabelaEvolucaoValorResgate,
                    type: 'bar',
                    data: aplicarInflacaoCarteiraInvestimentos(values, estudo,
                        estudo.current.graficoEstrategiasFinanceirasTabelaEvolucaoValorResgate, -1,
                            values.aplicarTaxaInflacaoCarteiraInvestimentos),
                },
            )

            paletaCoresEspecifica.push(
                COLOR().corChartPadraoTabelaEvolucaoValorResgate,
            )
        }
        
        if (
                values.exibirCapitalSeguradoCarteiraInvestimentos &&
                estudo.current.graficoEstrategiasFinanceirasVidaInteiraCotacao.length > 0
        ) {

            const dataVidaInteiraCotacao = aplicarInflacaoCarteiraInvestimentos(values, estudo,
                estudo.current.graficoEstrategiasFinanceirasVidaInteiraCotacao, -1,
                    values.aplicarTaxaInflacaoCarteiraInvestimentos)

            dataVidaInteiraCotacao[0] = dataVidaInteiraCotacao[1]

            series.push(
                {
                    name: LABEL.vidaInteira,
                    type: 'bar',
                    data: dataVidaInteiraCotacao,
                },
            )

            paletaCoresEspecifica.push(
                COLOR().corChartPadraoVidaInteiraCotacao,
            )
        }
        
        //if (
        //        values.exibirEconomiaInventarioSeguroVidaCarteiraInvestimentos &&
        //        estudo.current.graficoEstrategiasFinanceirasEconomiaInventarioSeguroVida.length > 0
        //) {

        //    const dataEconomiaInventarioSeguroVida =
        //        aplicarInflacaoCarteiraInvestimentos(values, estudo,
        //          estudo.current.graficoEstrategiasFinanceirasEconomiaInventarioSeguroVida, -1,
        //              values.aplicarTaxaInflacaoCarteiraInvestimentos)

        //    dataEconomiaInventarioSeguroVida[0] = dataEconomiaInventarioSeguroVida[1]
        
        //    series.push(
        //        {
        //            name: LABEL.valorEconomiaInventarioSeguroVida,
        //            type: 'bar',
        //            data: dataEconomiaInventarioSeguroVida,
        //        },
        //    )

        //    paletaCoresEspecifica.push(
        //        COLOR().corChartPadraoEconomiaInventarioSeguroVida,
        //    )
        //}

        serieVazia(series, estudo)

        const categories = estudo.current.graficoIdadesGraficos

        const GridGrafico =
            simulacaoFinanceira
                ? 
                    report && !popup ? GridItem12 : GridItem11
                :
                    report ? GridItem11 : GridItem11

        return (
            <div
                {...props}
            >
                <GridContainer>
                    <GridItem12>
                        <GridContainerS0>
                            <GridGrafico>
                                <ChartPadrao
                                    titleText={''} // mudança da fonte: titleText={LABEL.carteiraInvestimentos}
                                    titleTextPopup={LABEL.carteiraInvestimentos} // mudança da fonte
                                    type="area"
                                    series={series}
                                    height={
                                        simulacaoFinanceira
                                            ?
                                                popup ? 480 : 350 
                                            :
                                                report ? 350 : 500
                                    }
                                    stacked={true}
                                    categories={categories}
                                    categories2={estudo.current.graficoAnos}
                                    paletaCores={paletaCoresEspecifica}
                                    dataLabelsEnabled={values.modoApresentacao}
                                    dataLabelsEnabledReport={values.formatoReport === HARDCODE.idFormatoReportImpressao}
                                    dataLabelsType='Idade'
                                    dataLabelsDestaque={[values.idadeVaiAposentarCliente]}
                                    notInverseOrder={true}
                                    //legendFixedEnabled={true}
                                    toolTipX={true}
                                    toolTipXTotal={true}
                                    report={report}
                                    formatoReport={values.formatoReport}
                                    fillOpacity={0.75}
                                    participacao={true}
                                    zoom={true}
                                    titleZoomTabela={LABEL.recursoFinanceiro}
                                />
                            </GridGrafico>
                        </GridContainerS0>
                    </GridItem12>
                </GridContainer>
            </div>       
        )
    }

    return (
        <GridItem12>
            {report
                ?
                    <EstrategiasFinanceiras
                        className={popup ? 'mt-20' : simulacaoFinanceira ? 'mt-5' : ''/*'mt--5 ml-3' /* mudança da fonte: mt-3 */}
                    />
                :
                    <CardGridEstudoPadrao
                        label={
                            !relatorioModoApresentacao(values)
                                ?
                                    LABEL.carteiraInvestimentos
                                :
                                    HARDCODE.modoApresentacaoRelatorio
                        }
                        component={
                            <div
                                className='ml-10'
                            >
                                <EstrategiasFinanceiras/>
                            </div>
                        }
                        overflowX={false}
                    />
            }
        </GridItem12>
    )
}

export default CarteiraInvestimentosChart